/* istanbul ignore file */
import React from 'react';
import { useParams } from 'react-router-dom';
import AssignmentBreadcrumbs from 'domain/staffing/assignment/shared/AssignmentBreadcrumbs';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useAssignmentUrl } from 'domain/shared/assignment';
import { BreadcrumbsProps } from 'framework/ui/BreadCrumbs';

const SingleAssignmentBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  const { getSingleEntityUrl } = useAssignmentUrl();
  const { id } = useParams<Dictionary<string>>();

  return (
    <AssignmentBreadcrumbs>
      <SingleBreadcrumbItem entity={id!} link={getSingleEntityUrl(id)} />
      {children}
    </AssignmentBreadcrumbs>
  );
};

export default SingleAssignmentBreadcrumbs;
